import { render, staticRenderFns } from "./jjfa_list.vue?vue&type=template&id=064636f6&"
import script from "./jjfa_list.vue?vue&type=script&lang=js&"
export * from "./jjfa_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports